import { AutomateTask, success } from "@iflyrpa/share";
import { AxiosProxyParams, errorResponse } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";
import type { SearchAccountInfoParams } from ".";
import { type SearchAccountInfoResponse, type xhsConfigData } from "./types";

export async function getXiaohongshuData(
    _task: AutomateTask,
    params: SearchAccountInfoParams,
): Promise<SearchAccountInfoResponse> {
    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) {
        return errorResponse("账号数据异常，请重新绑定账号后重试。", 414);
    }
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://creator.xiaohongshu.com",
        origin: "https://creator.xiaohongshu.com",
    };
    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);
    const xsEncrypt = new Xhshow();

    const sevenDataUrl = "/api/galaxy/v2/creator/datacenter/account/base";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const sevenDataXsHeader = xsEncrypt.signHeadersGet(sevenDataUrl, recordCookie, "xhs-pc-web", null);

    const [overAllData, sevenData] = await Promise.all([
        http.api<{ data: { fans_count: number; faved_count: number } }>(
            {
                method: "get",
                url: "https://creator.xiaohongshu.com/api/galaxy/creator/home/personal_info",
            },
            { retries: 3, retryDelay: 20, timeout: 3000 },
        ),
        http.api<{
            data: {
                seven: {
                    view_count: number;
                    like_count: number;
                    collect_count: number;
                    comment_count: number;
                    rise_fans_count: number;
                    rise_fans_list: { data: number; count: number }[];
                };
            };
        }>(
            {
                method: "get",
                baseURL: "https://creator.xiaohongshu.com",
                url: sevenDataUrl,
                headers: sevenDataXsHeader,
            },
            { retries: 3, retryDelay: 20, timeout: 3000 },
        ),
    ]);

    const xhsData: xhsConfigData = {
        fansNum: overAllData.data.fans_count,
        favedNum: overAllData.data.faved_count,
        watchNumLastWeek: sevenData.data.seven.view_count,
        likeNumLastWeek: sevenData.data.seven.like_count,
        collectNumLastWeek: sevenData.data.seven.collect_count,
        commentNumLastWeek: sevenData.data.seven.comment_count,
        fansNumLastWeek: sevenData.data.seven.rise_fans_count,
        fansNumYesterday: sevenData.data.seven.rise_fans_list[0].count,
    };

    return success(xhsData, "小红书平台数据获取成功！");
}
